import { isServerRendering } from '@farmasiet/frontendcore-reactcomponents';
import React from 'react';

import { BreadcrumbsStyle } from '../../Common/Layout/BreadcrumbsStyle.csharp';
import { Breadcrumb, Breadcrumbs } from './Breadcrumbs';
import { BreadcrumbsViewModel } from './BreadcrumbsViewModel.csharp';

export const StaticBreadcrumbs = (viewModel: BreadcrumbsViewModel) => {
    const currentPageUrl = isServerRendering() ? '' : window.location.origin + window.location.pathname;
    const currentPageBreadcrumb: Breadcrumb = {
        text: viewModel.currentPageName,
        href: currentPageUrl,
        hideOnMobile: viewModel.style == BreadcrumbsStyle.NoCurrentPageOnMobile
    };

    return (
        <Breadcrumbs
            style={viewModel.style}
            breadcrumbs={[...viewModel.elements.map((element) => ({ text: element.text, href: element.href })), currentPageBreadcrumb]}
        />
    );
};
